import React from 'react'
import Icon from '../Display/Icon'

export default (props) => {
	if (props.state.nav.length > 1) {
		return (
			<div className='capps-navbar-tab left' onTouchTap={() => props.redux.nav.removePage()}>
				<div className='capps-navbar-icon'>
					<Icon name='arrow-left' color='dark' />
					back
				</div>
			</div>
		)
	}
	if (props.user && window.location.pathname.substr(1) !== 'settings') {
		return (
			<div className='capps-navbar-tab left' onTouchTap={() => props.redux.nav.addPage('settings')}>
				<div className='capps-navbar-icon'>
					<Icon name='settings' color='dark' />
					settings
				</div>
			</div>
		)
	}
	if (window.location.pathname.substr(1) === 'settings') {
		return (
			<div className='capps-navbar-tab right' onTouchTap={() => {
				window.history.pushState('', '', '/')
				props.redux.nav.setPage('')
			}}>
				<div className='capps-navbar-icon'>
					<Icon name='weather-night' color='dark' />
					moon
				</div>
			</div>
		)
	}
	return null
}



// WEBPACK FOOTER //
// ./src/Components/Nav/BackButton.js